import React, { useEffect, useState } from "react";
import { ChevronArrowDown } from "../../../assets/icons";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import { getFirstLetters, getGreeting } from "../../../utilities/commonUtilities";
import { useDispatch } from "react-redux";
import useProjectFacade from "../../../facade/project.Facade";


const DashBoardHeader: React.FC = () => {
    const dispatch = useDispatch();
    const { user } = useAppSelector((state) => state?.auth);
    const [greeting, setGreeting] = useState("Loading...");
    const { projectStatusCount }: any = useAppSelector((state) => state?.myProjects);
    const { loadProjectStatus, } = useProjectFacade();


    useEffect(() => {
        const now = new Date();
        setGreeting(getGreeting(now.getHours()));
        dispatch({ type: 'RESET_STORE' });
    }, []);

    useEffect(() => {
        if (projectStatusCount == null) {
            loadProjectStatus()
        }
    }, [projectStatusCount])

    return (
        <div
            className="px-[20px] py-[8px] flex flex-col lg:flex-row gap-[10px] items-center border-[1px] border-darkcolor-400 rounded-[8px] lg:justify-between mb-[20px] shadow-custom"
            style={{
                background:
                    "var(--Dark-Mode-Gradient-Cards, linear-gradient(181deg, #253240 -16.87%, rgba(37, 48, 64, 0.40) 35.14%))",
                height: "80px"
            }}
        >
            <div className="flex flex-col lg:flex-row lg:justify-between items-center lg:space-y-0">
                <div className="flex w-[65px] h-[65px] lg:w-[100px] lg:h-[100px] xl:w-[65px] xl:h-[65px] flex-col py-[22px] px-[24px] items-center justify-center shrink-0 gap-[8px] border-[5px] border-white bg-primary-500 rounded-full lg:mr-[24px] xl:mr-[32px] mb-4 lg:mb-0">
                    <label className="text-[16px] lg:text-[20px] xl:text-[20px] text-neutral-25 font-bold">
                        {user ? getFirstLetters(user?.userFullName) : getFirstLetters(greeting)}
                    </label>
                </div>
                <div className="flex flex-col md:text-center lg:text-left">
                    <h1 className="text-[24px] lg:text-[24px] xl:text-[24px] text-neutral-25 font-semi-bold leading-tight">
                        {`${greeting}${user ? `, ${user?.firstName}` : ""}`}
                    </h1>
                    <label className="text-[16px] lg:text-[16px] xl:text-[16px] text-neutral-200 font-normal text-left">
                        Here is your latest status report
                    </label>
                </div>
            </div>
            <div className="flex lg:flex-row gap-[42px]">
                <div className="flex p-[16px] items-center gap-[8px]">
                    <h2 className="text-[33px] lg:text-[33px] xl:text-[33px] font-bold text-neutral-25">
                        {projectStatusCount?.inProgress}
                    </h2>
                    <div className="flex items-center whitespace-nowrap">
                        <p className="text-[18px] lg:text-[18px] font-normal text-neutral-25">
                            In progress
                        </p>
                    </div>
                </div>
                <div className="w-[1px] my-[12px] bg-darkcolor-300" />
                <div className="flex p-[16px] items-center gap-[8px]">
                    <h2 className="text-[33px] lg:text-[33px] xl:text-[33px] font-bold text-neutral-25">
                        {projectStatusCount?.needReview}
                    </h2>
                    <div className="flex items-center whitespace-nowrap">
                        <p className="text-[18px] lg:text-[18px] font-normal text-neutral-25">
                            Need review
                        </p>
                    </div>
                </div>
                <div className="w-[1px] my-[12px] bg-darkcolor-300" />
                <div className="flex p-[16px] items-center gap-[8px]">
                    <h2 className="text-[33px] lg:text-[33px] xl:text-[33px] font-bold text-neutral-25">
                        {projectStatusCount?.complete}
                    </h2>
                    <div className="flex items-center whitespace-nowrap">
                        <p className="text-[18px] lg:text-[18px] font-normal text-neutral-25">
                        Acknowledged
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashBoardHeader;
